import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, FormGroupInputControl, connectedComponent, clearExceptions, Selector, loadFacilities, Modal } from 'gwx-voyager-components';
import { validateAddress, validateNPI, fetchHPDAddresses, createAdhocSubscription, validateSubscription } from '../../Subscription/subscriptions.actions';


/**
 * Returns whether the provided email is semantically valid.
 *
 * @param {String} email
 */
 function validateEmail(email) {
	const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
 }


/**
 * OpportunityForm component provides a form used to add Adhoc Subscription
 *
 * @class OpportunityForm
 * @extends {Component}
 */
class OpportunityForm extends Component {
	constructor(props) {
		super(props);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleOnBlur = this.handleOnBlur.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.handleSuccess = this.handleSuccess.bind(this);
		this.handleError = this.handleError.bind(this);
		this.confirmAdHocSubscription = this.confirmAdHocSubscription.bind(this);
		this.createSubscriptionConfirmationContent = this.createSubscriptionConfirmationContent.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
		this.onClickAddSubscription = this.onClickAddSubscription.bind(this);
		this.generateCheckBoxes = this.generateCheckBoxes.bind(this);
		this.handleCheck = this.handleCheck.bind(this);
		this.inputDisplayNames = {
			npi: 'NPI',
			sendingFacilityId: 'Sending Facility',
			directAddress: 'Direct Address (Enter a comma separated list or select at least one direct address)'
		};

		this.requiredFields = [this.inputDisplayNames.npi,this.inputDisplayNames.sendingFacilityId,this.inputDisplayNames.directAddress];
		this.directAddresses = [];
		this.state = {
			buttonsDisabled: false,
			npi: '',
			directAddress: '',
			sendingFacilityId: '',
			sendingFacilitySelector: null,
			sendingFacilityOptions: [],
			isEmailValid: false,
			isNPIValid: false,
			isSFValid: false,
			adHocSubscriptionModal: null,
			checkedDirectAddresses: [],
			isSubmit: false
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if ((Object.keys(this.props.exceptions).length === 0
			&& Object.keys(nextProps.exceptions).length !== 0)
			|| this.props.exceptions.timeStamp !== nextProps.exceptions.timeStamp) {
			this.setState({ buttonsDisabled: false });
		}
	}

	componentDidMount() {
		this.props.fetchSendingFacilities(this.props.communityId, { size: '1000' })
			.then(res => {
				if (res.type === 'SENDING_FACILITIES_SUCCESS') {
					this.setState((prevState) => ({
						...prevState,
						sendingFacilityOptions: this.props.sendingFacilities.map((value) => ({ value: value.displayName, label: value.displayName }))
					}));
				}
			});
	}

	componentWillUnmount() {
		if(this.props.exceptions !== undefined) {
			delete this.props.exceptions['fields'];
		}
		this.props.clearExceptions && this.props.clearExceptions();
	}

	/**
	 * Handles changing the value of an input.
	 *
	 * @param {Event} e
	 * 		The input change event.
	 */
	handleInputChange(e) {
		const { target } = e;

		if(target.name === 'npi' && target.value !== this.state.npi) {
			this.directAddresses = [];
			this.setState({
				checkedDirectAddresses: [],
				directAddress: ''
			})
			delete this.props.exceptions.fields;
		}

		this.setState({ [target.name]: target.value,  isSubmit: false});
	}

	handleError(field, error) {
		if(field === 'directAddress') {
			if(this.props.exceptions.fields !== undefined) {
				this.props.exceptions.fields[field] = error;
			}
			else {
				this.props.exceptions.fields = {
					directAddress: error
				};
			}
			this.setState({ isEmailValid: false });
		}
		else if(field === 'npi') {
			if(this.props.exceptions.fields !== undefined) {
				this.props.exceptions.fields[field] = error;
			}
			else {
				this.props.exceptions.fields = {
					npi: error
				};
			}
			this.setState({ isNPIValid: false });
		}
	}

	handleSuccess(field) {
		if(field === 'directAddress') {
			if(this.props.exceptions.fields !== undefined) {
				delete this.props.exceptions.fields[field];
			}
			this.setState({ isEmailValid: true });
		}
		else if(field === 'npi') {
			if(this.props.exceptions.fields !== undefined) {
				delete this.props.exceptions.fields[field];
			}
			let query = { npi : this.state.npi, communityId : this.props.communityId };
			this.props.fetchHPDAddresses(query);
			this.setState({ isNPIValid: true });
		}

		// checking all the input fields are valid and the call is made for direct address validation
		if(this.state.isEmailValid && this.state.isNPIValid && this.state.isSFValid && this.state.isSubmit) {
			let id = this.props.sendingFacilities.filter((value) => value.displayName === this.state.sendingFacilityId).map(value => value.id);
			let checkedAddresses = this.state.checkedDirectAddresses;
			if(checkedAddresses.length){
				checkedAddresses = checkedAddresses.map(function (address) {
					return address.split(" ")[0];
				});
			}
			// create adhoc subscription
			let subscription = {
				npi: this.state.npi,
				sendingFacilityId: id[0],
				manualAddressesLst: this.state.directAddress ? this.state.directAddress.split(',') : [],
				hpdAddresses: checkedAddresses
			};

			this.props.validateSubscription(subscription, this.confirmAdHocSubscription, this.handleError);
		}
	}

	confirmAdHocSubscription() {
		this.setState({
			adHocSubscriptionModal: <Modal
				title='Subscription Confirmation'
				content={this.createSubscriptionConfirmationContent()}
				show
				onClose={() => this.onModalClose()}
				closeLabel='Cancel'
				buttons={[
					<Button
						id='subscription-confirm'
						key='subscriptionConfirm'
						className='btn-success'
						onClick={() => {
							this.onClickAddSubscription(); this.onModalClose();
						}}
					>
						Confirm
					</Button>]}
			/>
		});
	}

	createSubscriptionConfirmationContent() {
		const displayProviderOrOrganizationName = () => {
			let name='';
			if(this.props.npiDetails[this.state.npi].nppesDemographic.organizationName != null && this.props.npiDetails[this.state.npi].nppesDemographic.organizationName!==''){
				name = <dd> {this.props.npiDetails[this.state.npi].nppesDemographic.organizationName} </dd>;
			}
			else if(this.props.npiDetails[this.state.npi].nppesDemographic.firstName === null && this.props.npiDetails[this.state.npi].nppesDemographic.lastName!=null){
				name = <dd> {this.props.npiDetails[this.state.npi].nppesDemographic.lastName}</dd> ;
			}
			else if(this.props.npiDetails[this.state.npi].nppesDemographic.lastName === null && this.props.npiDetails[this.state.npi].nppesDemographic.firstName!=null){
				name =  <dd>{this.props.npiDetails[this.state.npi].nppesDemographic.firstName}</dd>
			}
			else{
			  name = <dd>{this.props.npiDetails[this.state.npi].nppesDemographic.lastName}, {this.props.npiDetails[this.state.npi].nppesDemographic.firstName}</dd>
			}
			return name;
		}

		let hpdDA = this.state.checkedDirectAddresses.map(address => <div>{address}</div>)
		return (
			<div className='text-justify'>
				<p>
					Confirm	the details below for your new subscription for
					{' '}
					<b>{this.state.sendingFacilityId}</b>
					.
				</p>
				<dl>
					<dt>NPI:</dt>
					<dd>{this.state.npi}</dd>
					<dt>Name: </dt>
					<dd>{displayProviderOrOrganizationName()}</dd>
					<dt>Practice Address:</dt>
					<dd>{this.props.npiDetails[this.state.npi].nppesDemographic.address1}</dd>
					<dd>{this.props.npiDetails[this.state.npi].nppesDemographic.city} {this.props.npiDetails[this.state.npi].nppesDemographic.state} {this.props.npiDetails[this.state.npi].nppesDemographic.postalCode}</dd>
					<dt>Direct Address:</dt>
					<dd>
						<div>{this.state.directAddress ?  `${this.state.directAddress}  (MANUAL)` : '' } </div>
						{hpdDA}
					</dd>
				</dl>
			</div>
		);
	}


	onClickAddSubscription() {
		let id = this.props.sendingFacilities.filter((value) => value.displayName === this.state.sendingFacilityId).map(value => value.id);
		let checkedAddresses = this.state.checkedDirectAddresses;
		if(checkedAddresses.length){
			checkedAddresses = checkedAddresses.map(function (address) {
				return address.split(" ")[0];
			});
		}
		// create adhoc subscription
		let subscription = {
			npi: this.state.npi,
			sendingFacilityId: id[0],
			manualAddressesLst: this.state.directAddress ? this.state.directAddress.split(',') : [],
			hpdAddresses: checkedAddresses,
			demographics: this.props.npiDetails[this.state.npi].nppesDemographic,
			sendingFacilityDisplayName: this.state.sendingFacilityId
		};

		this.props.createAdhocSubscription(subscription, this.props.communityId);
	}

	onModalClose() {
		this.setState({
			adHocSubscriptionModal: null
		});
	}

	/**
	 *
	 * @param {Array} - Arrays need to be Manipulated with the type of Source
	 * @param {source} - Soure need to be appended to arrayOfValues
	 * @return Array of manipulated object.
	 *
	 */
	 generateSourceArray = (arrayOfValues, source) => {
		return arrayOfValues.map(function(item) {
			return {
				directAddress: item.directAddress.concat(this),
				isTrusted: item.isTrusted
			}
		}, source);
	}
	/**
	 *
	 * @param {array1, array2} - Arrays need to be validated
	 * @param {isCommon} - true / false, if true get common elements else get non common elements
	 *
	 * we are using array#filter with
	 * 		-> array#some, "Will provide common elements" &
	 * 		-> !array#some, "Will provide non common elements"
	 *
	 * For each object in the first array, check if directAddress and isTrusted exist in the other array.
	 * @return Array of object wither common or non common elements.
	 *
	 */
	getCommonArray = (array1, array2, isCommon) => {
		return isCommon ? array1.filter(o1 => array2.some(o2 => JSON.stringify(o1) === JSON.stringify(o2))) :
		array1.filter(o1 => !array2.some(o2 => JSON.stringify(o1) === JSON.stringify(o2)));
	}

	/**
	 * A function for mapping direct addresses into an array of checkbox inputs
	 *
	 * @param {Array} directAddresses - An array of direct address objects
	 */
	 generateCheckBoxes() {
		if(this.props.hpdDetails[this.state.npi] !== undefined) {
			let hpdAdd = [...this.props.hpdDetails[this.state.npi].hpdAddresses];
			let nppesAdd = [...this.props.npiDetails[this.state.npi].nppesDirectAddresses];
			let hpdNppes = [];
			// Apending source(HPD / NPPES / NPPES & HPD) to the directAdress
			if (hpdAdd.length && nppesAdd.length) {
				// getting Common elements from HPD & NPPES arrays
				let filteredArray = this.getCommonArray(hpdAdd, nppesAdd, true);

				// Removing common elements from HPD & NPPES
				hpdAdd = this.getCommonArray(hpdAdd, filteredArray, false);
				nppesAdd = this.getCommonArray(nppesAdd, filteredArray, false);

				if (filteredArray.length) {
					hpdNppes = this.generateSourceArray(filteredArray, " (NPPES & HPD)");
				}
			}

			if (hpdAdd.length) {
				hpdAdd = this.generateSourceArray(hpdAdd, " (HPD)");
			}

			if (nppesAdd.length) {
				nppesAdd = this.generateSourceArray(nppesAdd, " (NPPES)");
			}

			this.directAddresses = hpdNppes.concat(hpdAdd, nppesAdd);

			/**
			 * #Array.sort() - to sort the emelnts in specfic order - here we are using boolean attribute
			 * b-a -> true...false
			 * a-b -> false...true
			 */
			this.directAddresses.sort((a,b) => b.isTrusted - a.isTrusted);
		}

		const addresses = this.directAddresses.map((address) => (
			<div className='checkbox direct-address-checkbox' key={address.directAddress}>
				<input
					name={`option-${address.directAddress}`}
					type='checkbox'
					className='mr-2'
					value={address.directAddress || ''}
					onChange={(e) => this.handleCheck(e)}
					disabled={!address.isTrusted}
					checked={this.state.checkedDirectAddresses.includes(address.directAddress)}
				/>
				<label htmlFor={`option-${address.directAddress}`}>
					{address.isTrusted ? address.directAddress : `(Not Trusted) ${address.directAddress}`}
				</label>
			</div>
		));
		return (
			<div>
				{addresses}
			</div>
		);
	}

	/**
	 * Handles an input check.
	 *
	 * @param {Object} e - event object
	 */
	 handleCheck(e) {
		const directAddress = e.target.value;
		let directAddressesTemp = this.state.checkedDirectAddresses;
		if (e.target.checked) {
			directAddressesTemp.push(directAddress);
		} else if (directAddressesTemp && directAddressesTemp.length > 0) {
			const index = directAddressesTemp.indexOf(directAddress);
			if (index > -1) {
				directAddressesTemp.splice(index, 1);
			}
		}
		this.setState({ checkedDirectAddresses: directAddressesTemp });
	}

	handleOnBlur(e) {
		const { target } = e;
		this.setState({ [target.name]: target.value.trim(),  isSubmit: false});

		if(target.name === 'npi') {
			if(this.state.npi.length === 0) {
				if(this.props.exceptions.fields === undefined) {
					this.props.exceptions.fields = {
						npi: 'A subscription requires a npi that is not blank.'
					};
				} else {
					this.props.exceptions.fields['npi'] = 'A subscription requires a npi that is not blank.';
				}
				this.setState({ isNPIValid: false });
			}
			else if(this.state.npi.length > 0) {
				let query = { npi : target.value.trim(), communityId : this.props.communityId };
				this.props.validateNPI(query, target.name, this.handleSuccess, this.handleError);
			}
		}
	}

	/**
	 * Handles changing the value of the Selector input.
	 *
	 * @param {Event} e
	 * 		The input change event.
	 */
	 handleSelectChange(e) {
		this.setState({ sendingFacilityId: e ? e.value : '', sendingFacilitySelector: e });
	}

	/**
	 * Handles submitting the Opportunity form.
	 *
	 * @param {Event} e
	 * 		The form submission event.
	 */
	handleSubmit(e) {
		e.preventDefault();
		// validating the required fields.
		// directAddress validation
		this.setState({isSubmit: true});
		let invalidEmailsLst = []
		this.state.directAddress.split(',').filter(x=>!(x.trim().length===0)).forEach(add=> {
			if(!validateEmail(add.trim()))
			invalidEmailsLst.push(add.trim());
		})
		let  invalidEmails= invalidEmailsLst.join(',');
		if(this.state.directAddress.length === 0 && this.state.checkedDirectAddresses.length === 0) {
			if(this.props.exceptions.fields === undefined) {
				this.props.exceptions.fields = {
					directAddress: 'A subscription requires a direct address that is not blank.'
				};
			} else {
				this.props.exceptions.fields['directAddress'] = 'A subscription requires a direct address that is not blank.';
			}
			this.setState({ isEmailValid: false });
		}
		else if(this.state.directAddress && invalidEmails.length>0) {
			if(this.props.exceptions.fields === undefined) {
				this.props.exceptions.fields = {
					directAddress: `The following email addresses are invalid: (${invalidEmails}) Please fix or remove these.`
				};
			} else {
				this.props.exceptions.fields['directAddress'] = `The following email addresses are invalid: (${invalidEmails}) Please fix or remove these.`
			}
			this.setState({ isEmailValid: false });
		}
		else {
			let checkedAddresses = this.state.checkedDirectAddresses;
			if(checkedAddresses.length){
				checkedAddresses = checkedAddresses.map(function (address) {
					return address.split(" ")[0];
				});
			}
			let query = { directAddress: this.state.directAddress.split(',').filter(x=>!(x.trim().length===0)), checkedDirectAddresses: checkedAddresses };
			this.props.validateAddress(query, 'directAddress', this.handleSuccess, this.handleError);
		}

		// npi validation
		if(!this.state.isNPIValid) {
			if(this.state.npi.length === 0) {
				if(this.props.exceptions.fields === undefined) {
					this.props.exceptions.fields = {
						npi: 'A subscription requires a npi that is not blank.'
					};
				} else {
					this.props.exceptions.fields['npi'] = 'A subscription requires a npi that is not blank.';
				}
				this.setState({ isNPIValid: false });
			}
			else if(this.state.npi.length > 0) {
				let query = { npi : this.state.npi, communityId : this.props.communityId };
				this.props.validateNPI(query, 'npi', this.handleSuccess, this.handleError);
			}
		}


		// sending facility validation
		if(this.state.sendingFacilityId.length === 0) {
			if(this.props.exceptions.fields === undefined) {
				this.props.exceptions.fields = {
					sendingFacilityId: 'A subscription requires a sending facility that is not blank.'
				};
			} else {
				this.props.exceptions.fields['sendingFacilityId'] = 'A subscription requires a sending facility that is not blank.';
			}
			this.setState({ isSFValid: false });
		}
		else {
			if(this.props.exceptions.fields !== undefined) {
				delete this.props.exceptions.fields['sendingFacilityId'];
			}
			this.setState({ isSFValid: true });
		}

	}


	render() {
		const inputArr = Object.keys(this.inputDisplayNames).map((input) => {
			const inError = !!(this.props.exceptions.fields && this.props.exceptions.fields[input]);
			const selectInput = input === 'sendingFacilityId'
				? {
					componentClass: Selector,
					onChange: this.handleSelectChange,
					value: this.state.sendingFacilitySelector,
					reference: (node) => (this[input] = node),
					componentRef: null,
					options: this.state.sendingFacilityOptions,
					async: false
				}
				: {};
			return (
				<FormGroupInputControl
					control={{
						id: input,
						name: input,
						onChange: this.handleInputChange,
						onBlur: this.handleOnBlur,
						value: this.state[input] || '',
						inError,
						...selectInput
					}}
					helpText={inError ? this.props.exceptions.fields[input] : null}
					key={input}
					label={this.inputDisplayNames[input]}
					isRequired={this.requiredFields.includes(this.inputDisplayNames[input]) ? true : false}
				/>
			);
		});

		const formProps = {
			buttonsDisabled: this.state.buttonsDisabled,
			legend: this.props.legend,
			fieldRequiredText: this.requiredFields !== undefined && this.requiredFields.length > 0,
			onClickDiscard: () => this.props.discard(this.props.communityId),
			onSubmit: this.handleSubmit
		};

		return (
			<Form {...formProps}>
				{inputArr}
				{this.generateCheckBoxes(this.directAddresses)}
				{this.state.adHocSubscriptionModal}
			</Form>

		);
	}
}

OpportunityForm.defaultProps = {
	legend: 'Create Subscription',
	exceptions: {}
};

OpportunityForm.propTypes = {
	/**
	 * Function for clearing the exceptions from the
	 * store.
	 */
	 clearExceptions: PropTypes.func.isRequired,
	 discard: PropTypes.func.isRequired,
	 exceptions: PropTypes.shape({
		 fields: PropTypes.object,
		 timeStamp: PropTypes.number
	 }).isRequired,
	 /*save: PropTypes.func.isRequired,
	 */
	 legend: PropTypes.string
};

/**
 * Returns a set of functions that can utilize a dispatcher to dispatch actions.
 * These are the action creators for the OpportunityForm component.
 *
 * @param {function} dispatch
 * 		The redux dispatcher.
 * @param {object} props
 * 		The props being passed to the component.
 */
 const mapDispatchToProps = (dispatch, props) => ({

	clearExceptions: () => { dispatch(clearExceptions); },
	/**
	 * Discards the form.
	 */
	discard: (communityId, response) => {
			dispatch(clearExceptions);
			props.history.push(`/${communityId}/opportunities`);
	},
	fetchSendingFacilities: (communityId, query) => dispatch(loadFacilities({ communityId, ...query })),

	/**
	 * Verifys if the direct address is trusted.
	 *
	 * @param {Object} directAddress - the direct address to verify the trust.
	 */
	validateAddress: (directAddress, field, successCallback, errorCallback) => dispatch(
		 validateAddress(directAddress))
		 .then((response) => {
			 if (response.error) {
				errorCallback(field, response.error.fields.email);
				return;
			 }

			 if (successCallback) {
				successCallback(field);
				return;
			}
		 }),


	fetchHPDAddresses: (query) => dispatch(fetchHPDAddresses(query)),

	/**
	 * Creates a single subscription.  Triggers an alert based on the
	 * response of creating the subscription.
	 *
	 * @param {Object} subscription - the subscription to create.
	 */
	createAdhocSubscription: (subscription, communityId) => (dispatch(
		createAdhocSubscription(subscription)
	).then((response) => {
		const exception = response.error;
		if (undefined !== exception) {
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'danger',
					dismissable: true,
					children: exception.message,
					html: true,
					duration: 10000
				}
			});
		}
		else {
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'success',
					dismissable: true,
					message: 'Subscription successfully created',
					duration: 5000
				}
			});
			props.history.push(`/${communityId}/subscriptions`);
		}
	})),

	/**
	 * Verifys if the NPI is valid.
	 *
	 * @param {Object} npi - to check npi is valid.
	 */
	 validateNPI: (query, field, successCallback, errorCallback) => dispatch(
		validateNPI(query))
		.then((response) => {
			if (response.error) {
			   errorCallback(field, response.error.fields.npi);
			   return;
			}

			if (successCallback) {
			   successCallback(field);
			   return;
		   }
		}),

	/**
 	* Verifys if the subscription is valid.
	*
	* @param {Object} subscription - to check subscription is valid.
	*/
	validateSubscription: (subscription,successCallback,errorCallback) => dispatch(
		validateSubscription(subscription)
	).then((response) => {
		const exception = response.error;
		if (!exception) {
			if(successCallback){
				successCallback();
			   return;
			}
		}else{
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'danger',
					dismissable: true,
					children: response.error.message,
					html: true,
					duration: 5000
				}
			});
			errorCallback('subscriptionvalidation', response.error.message);
			return;
		}
	}),
});

/**
 * Maps the current state of the Redux store to a set of
 * properties to be passed to the component.
 *
 * @param {object} state
 *  @param {object} props
 */
const mapStateToProps = (state, props) => {

	const {
		entities: { sendingFacilities, npiDetails, hpdDetails }
	} = state;

	const {
		match: { params: { id: communityId } },
	} = props;

	return {
		communityId,
		npiDetails,
		hpdDetails,
		sendingFacilities: sendingFacilities.ids.map(
			(id) => sendingFacilities.results[id]
		)
	};

};


const OpportunityFormContainer = connectedComponent(OpportunityForm, mapStateToProps, mapDispatchToProps);

export {
	OpportunityFormContainer as default,
	mapDispatchToProps,
	OpportunityForm
};
